import "../../chunk-7QVYU63E.js";
import { TeamPlanTier } from "#teamPlan/teamPlan.js";
const TIERED_CU_PRICING = {
  [TeamPlanTier.FREE]: [
    {
      min: 0,
      price: 0
    }
  ],
  [TeamPlanTier.GROWTH]: [
    {
      min: 0,
      price: 12e-7
    }
  ],
  [TeamPlanTier.SCALE]: [
    {
      min: 0,
      price: 1e-6
    }
  ],
  [TeamPlanTier.PAYG]: [
    {
      min: 0,
      max: 3e8,
      price: 0.45 * 1e-6
    },
    {
      min: 3e8,
      price: 0.4 * 1e-6
    }
  ]
};
const TEAM_ID_TIERED_CU_PRICING_OVERRIDES = {
  6013444: [
    // Gensyn
    {
      min: 0,
      max: 75e8,
      price: 3e-7
    },
    {
      min: 75e8,
      max: 225e8,
      price: 1e-7
    },
    {
      min: 225e8,
      price: 4e-8
    }
  ]
};
export {
  TEAM_ID_TIERED_CU_PRICING_OVERRIDES,
  TIERED_CU_PRICING
};
//# sourceMappingURL=tieredPricing.js.map